export const TaskStatus = {
  NEW: 'NEW',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};
